import React, {useState} from 'react'
import UsersTable from './usersTable'

const filters = {
    active: false
}

export default function UsersList(props) {

    return(
        <div>
            <h1>
                Inactive Users
            </h1>
            <p>
                These users are inactive and cannot log in to the system until they are made active again.
            </p>
            <UsersTable
                filters={filters} 
                enableCrud={true}
            />
        </div>
    )
}